import { combineReducers } from "redux"

import commonReducer from "./commonReducers"
import coronationReducer from "./coronation/reducer"

export default combineReducers({
	common: commonReducer,
	coronation: coronationReducer,
})
